import { SetStateAction } from "react";
import Link from "next/link";
import { BookDemoHubspotButtonUrl } from "@/utils/hubspot-contants";
import lightCheckIcon from "@/assets/images/pricing/light-check.svg";
import darkCheckIcon from "@/assets/images/pricing/dark-check.svg";
import Image from "next/image";

type TPriceProps = {
  intro: string;
  subtitle?: string;
  price: null | {
    monthly: number;
    yearly: number;
  };
  buttonText: string;
  featureList: string[];
  customHeaderText?: string;
};

const SinglePriceCard = ({
  info,
  packageTime,
  defaultShow,
  setHighlightPackage,
  packageNumber,
  highlightPackage,
  isDark: isDarkProp,
}: {
  info: TPriceProps;
  defaultShow?: boolean;
  packageTime: string;
  setHighlightPackage: React.Dispatch<SetStateAction<number | null>>;
  packageNumber: number;
  highlightPackage: number | null;
  isDark?: boolean;
}) => {
  const isBusiness = isDarkProp ?? packageNumber === 3;
  const isDark = isBusiness;

  return (
    <div
      onMouseOver={() => {
        if (highlightPackage !== packageNumber) {
          setHighlightPackage(null);
        }
      }}
      className="relative rounded-[12px]"
    >
      <div
        className={`h-full overflow-hidden rounded-[12px] ${
          isDark ? "bg-[#000000]" : "border border-[#E6E6F5] bg-white"
        }`}
      >
        <div className="flex h-full w-full flex-col rounded-[12px] p-5">
          <div className="relative z-40 space-y-2 xl:min-h-[80px]">
            <div
              className={`w-fit rounded-md px-3 py-1.5 ${isDark ? "border border-[#E6E6F5] bg-transparent" : "bg-[#F0EFFF]"}`}
            >
              <p
                className={`text-[14px] font-medium ${isDark ? "text-white" : "text-[#202020]"}`}
              >
                {info.intro}
              </p>
            </div>
            {info.customHeaderText ? (
              <>
                <p
                  className={`text-[18px] font-medium ${isDark ? "text-white" : "text-[#202020]"}`}
                >
                  {info.customHeaderText}
                </p>
              </>
            ) : info.price ? (
              <>
                <div
                  className={`flex items-baseline gap-1 font-medium ${isDark ? "text-white" : "text-[#202020]"}`}
                >
                  <p className="text-[32px] font-semibold">
                    $
                    {packageTime === "monthly"
                      ? info.price.monthly
                      : info.price.yearly}
                  </p>
                  <span
                    className={`text-[14px] ${isDark ? "text-white/90" : "text-[#717171]"}`}
                  >
                    / User / Month
                  </span>
                </div>
              </>
            ) : (
              <>
                <p
                  className={`text-[32px] font-semibold ${isDark ? "text-white" : "text-[#202020]"}`}
                >
                  $0
                </p>
              </>
            )}
          </div>
          <div className="relative z-40 flex h-full flex-col">
            <div className="py-4">
              <div
                className={`rounded-lg ${
                  isBusiness
                    ? "bg-white hover:bg-white/95"
                    : "bg-[#000000] hover:bg-[#000000]/90"
                }`}
              >
                <Link
                  href={BookDemoHubspotButtonUrl}
                  target="none"
                  rel="noopener noreferrer"
                  className={`flex w-full items-center justify-center rounded-lg p-2.5 text-[14px] font-medium duration-200 ${
                    isBusiness ? "text-[#202020]" : "text-white"
                  }`}
                >
                  <span>{info.buttonText}</span>
                </Link>
              </div>
            </div>
            <div className="flex flex-grow flex-col gap-3 px-0">
              {info.featureList.map((item, index) => (
                <div
                  className={`flex gap-2 text-[14px] font-normal ${isDark ? "text-white" : "text-[#202020]"}`}
                  key={index}
                >
                  {isDark ? (
                    <Image
                      src={lightCheckIcon}
                      alt="Plan feature included"
                      width={14}
                      height={14}
                    />
                  ) : (
                    <Image
                      src={darkCheckIcon}
                      alt="Plan feature included"
                      width={14}
                      height={14}
                    />
                  )}
                  <span>{item}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SinglePriceCard;
